import React, { useState, useEffect } from 'react';
import Footer from './footer';
import CustomWizard from './CustomWizard';
import Paso1 from '../Formulario/paso1';
import Paso2 from '../Formulario/paso2';
import Paso4 from '../Formulario/paso4';
import Paso3 from '../Formulario/paso3';
import ResultadoSolicitud from '../Formulario/resultadoSolicitud';
import Bienvenida from '../Formulario/bienvenida';
import Menu2 from './menu2';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

const LayoutFormulario = (props) => {
    const { t } = useTranslation();
    const [ModoPrueba] = useState(false);

    function ValidarPaso1() {
        if (ModoPrueba) return true;

        const paso1ValidadoStorage = window.localStorage.getItem("Paso1");
        const tieneDocumentosStorage = window.localStorage.getItem("TieneDocumentos");

        if (tieneDocumentosStorage === "false") {
            return true;
        } else if (tieneDocumentosStorage === "true") {
            if (paso1ValidadoStorage === btoa(true.toString())) {
                return true;
            } else if (paso1ValidadoStorage === btoa(false.toString())) {
                toast.error(t('layout.errorPaso1Completo', 'Debe llenar todos los campos obligatorios y corregir los errores en el Paso 1 para continuar.'));
                return false;
            } else {
                toast.error(t('layout.errorPaso1Info', 'Información incompleta en el Paso 1. Por favor, verifique los campos.'));
                return false;
            }
        } else {
            toast.error(t('layout.errorValidacion', 'Por favor, complete la validación inicial para continuar.'));
            return false;
        }
    }

    function ValidarPaso2() {
        if (ModoPrueba) return true;

        if (navigator.onLine) {
            return true;
        } else {
            toast.error(t('layout.errorSinInternet', 'Actualmente no posee conexión a internet.'));
            return false;
        }
    }

    function ValidarPaso3() {
        if (ModoPrueba) return true;

        if (navigator.onLine) {
            var Paso3Validado = window.localStorage.getItem("Paso3");
            if (Paso3Validado === btoa(false.toString())) {
                toast.error(t('layout.errorPaso3Completo', 'Debe llenar los campos obligatorios en el Paso 3 para continuar.'));
                return false;
            } else if (Paso3Validado === btoa(true.toString())) {
                return true;
            } else {
                toast.error(t('layout.errorPaso3Info', 'Información incompleta en el Paso 3. Por favor, verifique los campos.'));
                return false;
            }
        } else {
            toast.error(t('layout.errorSinInternet', 'Actualmente no posee conexión a internet.'));
            return false;
        }
    }

    const step0Content = <Bienvenida />;
    const step1Content = <Paso1 />;
    const step2Content = <Paso2 />;
    const step3Content = <Paso3 />;
    const step4Content = <Paso4 />;
    const step5Content = <ResultadoSolicitud />;

    const Pasos = React.useMemo(() => [
        {
            name: 'Bienvenida',
            label: t('layout.pasoBienvenida', 'Bienvenida'),
            content: step0Content,
            validator: () => true
        },
        {
            name: 'Validación',
            label: t('layout.pasoValidacion', 'Validación'),
            content: step1Content,
            validator: ValidarPaso1
        },
        {
            name: 'Boleto',
            label: t('layout.pasoBoleto', 'Boleto'),
            content: step2Content,
            validator: ValidarPaso2
        },
        {
            name: 'Motivo',
            label: t('layout.pasoMotivo', 'Motivo'),
            content: step3Content,
            validator: ValidarPaso3
        },
        {
            name: 'Documentos',
            label: t('layout.pasoDocumentos', 'Documentos'),
            content: step4Content,
            validator: () => true
        },
        // {
        //     name: 'Resultado', 
        //     label: t('layout.pasoResultado', 'Resultado'),
        //     content: step5Content,
        //     validator: () => true 
        // }
    ], [t, ModoPrueba]);

    useEffect(() => {
    }, []);

    function onFormSubmit() {
        console.log("Formulario completado y enviado (simulado)");
        toast.success(t('layout.exitoProcesado', 'Su solicitud de reembolso ha sido procesada (simulación).'));
    }

    return (
        <>
            <Menu2 />
            <div className="theme-page-section _pt-90" style={{ minHeight: "100vh" }}>
                <div className="container">
                    <CustomWizard
                        primaryBtnClass={"btn btn-primary _bg-p"}
                        secondaryBtnClass={"btn btn-primary-inverse _c-dark btn-white hover-Oscuro"}
                        previousBtnName={t('layout.btnAnterior', 'Anterior')}
                        nextBtnName={t('layout.btnSiguiente', 'Siguiente')}
                        startingStep={0}
                        onSubmit={onFormSubmit}
                        steps={Pasos}
                    />
                </div>
            </div>
            <Footer />
        </>
    );
}
export default LayoutFormulario;